/**
 * Dòng phụ của danh sách "Khách vừa đặt hoặc vừa tới" (màn Tìm khách, ô tìm trống).
 *
 * Lỗi 16/10: khách đặt qua Mini App nhưng chưa tới không có trong danh sách (máy chủ chỉ lấy `last_visit_at`, cột chỉ
 * được ghi khi khách ĐÃ TỚI). Máy chủ giờ trả thêm `datLichLuc` (lúc tạo lịch còn hiệu lực gần nhất); mốc nào mới hơn
 * thì dòng phụ nói mốc đó: "Tới dd/MM" hoặc "Đặt lịch dd/MM".
 */
export interface MocKhach {
  readonly lastVisitAt?: string | null
  readonly datLichLuc?: string | null
}

export type MocGanDay = { loai: 'toi' | 'dat'; iso: string } | null

export function mocGanDay(k: MocKhach): MocGanDay {
  const toi = k.lastVisitAt ?? null
  const dat = k.datLichLuc ?? null
  if (toi === null && dat === null) return null
  if (dat === null) return { loai: 'toi', iso: toi as string }
  if (toi === null) return { loai: 'dat', iso: dat }
  return Date.parse(toi) >= Date.parse(dat) ? { loai: 'toi', iso: toi } : { loai: 'dat', iso: dat }
}
